import { faArrowDownToLine } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SlideOverContext } from "@notanumber/nan-component-library";
import Block from "components/General/Block";
import { SlideOverCustomization } from "hooks/slideOver";
import { printHTML } from "hooks/utils/formatter";
import { useContext, useMemo } from "react";
import ProductProperties from "../ProductProperties/ProductProperties";
import ProductImages from "./ImagesSlider/ProductImages";
import ProductInfoButtons from "./ProductInfoButtons";
import ProductAttributes from "../ProductAttributes/ProductAttributes";
import useMediaQuery from "hooks/useMediaQuery";

const ProductInformation = ({
  page,
  product,
  preparation_packages,
  setSelectedVariationId,
  selected_image,
  showProperties,
}) => {
  const { setSlideOver } = useContext(SlideOverContext);
  const thumb_image = product?.thumbnail || null;
  const gallery_images = product?.gallery_images || null;

  const { all_images, latestUpdate } = useMemo(() => {
    let _images = [];
    if (gallery_images) {
      _images = [...gallery_images];
    }
    if (thumb_image) {
      _images.unshift(thumb_image);
    }
    if (selected_image) {
      _images.unshift(selected_image);
    }
    return { all_images: _images, latestUpdate: Date.now() };
  }, [selected_image, gallery_images, thumb_image]);

  const product_attributes = product?.properties;
  const product_description = product?.content;
  const product_downloads = product?.downloads;

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <ProductImages images={all_images} key={latestUpdate} />

      {showProperties && (
        <ProductProperties
          page={page}
          selected_image={selected_image}
          preparation_packages={preparation_packages}
          setSelectedVariationId={setSelectedVariationId}
        />
      )}

      <div className="lg:hidden">
        <ProductAttributes product_attributes={product_attributes} />
      </div>

      {product_description && (
        <Block className="px-8 py-8 bg-white md:px-10">
          <h3>Productomschrijving</h3>
          {printHTML(product_description)}
        </Block>
      )}

      {(product_downloads && product_downloads?.length > 0) && (
        <Block className="bg-white">
          <ProductInfoButtons
            className={`px-4 md:px-0`}
            onClick={() => {
              setSlideOver(
                <div className="px-8 md:px-[4.5rem] w-[calc(100vw-24px)] md:w-[37.5rem]">
                  <h3 className="md:text-[2rem] leading-10 md:mb-8 mb-4 text-xl">Downloads</h3>
                  <div className="flex flex-col gap-4">
                    {product_downloads.map((download) => {
                      return (
                        <a
                          key={download?.id}
                          href={download?.url}
                          title={download?.name}
                          target="_blank"
                          className="flex items-center gap-3 no-underline text-dark-text"
                          download
                        >
                          <div className="flex items-center justify-center w-6 h-6 rounded-full bg-body">
                            <FontAwesomeIcon icon={faArrowDownToLine} className="w-4 h-4" />
                          </div>
                          <span>
                            {download?.name || "Download"}{" "}
                          </span>
                        </a>
                      );
                    })}
                  </div>
                </div>,
                SlideOverCustomization
              );
            }}
          >
            Downloads
          </ProductInfoButtons>
        </Block>
      )}
    </div>
  );
};

export default ProductInformation;
